const API_ROUTES = {
  DASHBOARD: {
    GET: "admin/get-dashboard-data",
  },

  AUTH: {
    LOGIN: "/admin/login",
    CHANGE_PASSWORD: "/admin/change-password",
    UPDATE: "/admin/update-profile",
    GET_PROFILE: "/admin/get-profile",
  },

  ADMIN: {
    LIST: "/admin/get-admins",
    CREATE: "/admin/create-admin-user",
    PASSWORD_RESET: "/admin/admin-change-password",
    REMOVE: "/admin/remove-admin",
  },

  ETSY: {
    GET_ACCOUNTS: "/admin/etsy-accounts",
    CREATE_ACCOUNT: "/admin/etsy-accounts-create",

    UPDATE_ACCOUNT: "/admin/etsy-accounts",
    TOGGLE_ACCOUNT: "/admin/etsy-accounts/toggle",

    DELETE_ETSY_ACCOUNT: "/admin/etsy-accounts/delete",

    TOGGLE_AUTO_UPDATE: "/admin/etsy-accounts/auto-update",

    SYNC_LISTINGS: "/etsy/sync-listings",
    GET_LISTING: "/etsy/listing",
    UPDATE_SINGLE_Listing: "/etsy/listing",

    UPDATE_PRICE_ON_ETSY: "/etsy/push-price",

    GET_PRODUCT_LIST: "/admin/products",
    GET_PRODUCT_BY_LISTING_ID: "/admin/products/product-by-listing-id",

    TEST_GOLD: "/etsy/test-gold-price",
  },

  SETTINGS: {
    GET: "/admin/settings",
    UPDATE: "/admin/settings/update",
  },

  DIAMOND: {
    UPLOAD: "/admin/diamonds/upload",
    GET_RATES: "/admin/diamonds",
    ADD_RATE: "/admin/diamonds/add",
    UPDATE_RATE: "/admin/diamonds/update",
    DELETE_RATE: "/admin/diamonds/delete",
  },

  GOLD: {
    GET_GOLD_RATES: "/admin/gold-rates/",
    GET_GOLD_RATES_WITH_API: "/admin/gold-rates/update-by-api",
    ADD_GOLD_RATE: "/admin/gold-rates/add",
    UPDATE_GOLD_RATE: "/admin/gold-rates/update",
    DELETE_GOLD_RATE: "/admin/gold-rates/delete",
  },

  LOGS: {
    GET: "/admin/logs",
  },
};

export default API_ROUTES;
